import ApiService from "../ApiService";
import { AxiosResponse } from "axios";

export const Subscribe = (params): Promise<AxiosResponse> => {
  ApiService.setHeader();
  return ApiService.post("/users/subscribeV2", params);
};

// /v1/erssu / subscribeV2;
